import { render, staticRenderFns } from "./UserPickerInput.vue?vue&type=template&id=6818f364"
import script from "./UserPickerInput.vue?vue&type=script&lang=js"
export * from "./UserPickerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports